<template>
  <div style="width:100%" class="elevation-2 pt-3 pl-3 pr-3">
    <Loading :value="loading"></Loading>
    <h4 mt-2>WORKLOG</h4>
    <v-divider></v-divider>
    <v-layout wrap mt-3>
      <v-flex xs12 class="text-xs-right">
         <v-tooltip top>
           <v-btn
             v-if="true"
             slot="activator"
             color="orange"
             :disabled="false"
             @click.stop="imprimeMatricePDF()"
             dark
           >
             Imprimer
             <v-icon right>print</v-icon>
           </v-btn>Imprimer le worklog
         </v-tooltip>

            <v-btn
                icons
                color="primary"
                @click="showAjoutWork()"
                dark
              >
                Ajouter
                <v-icon right>add</v-icon>
              </v-btn>
      </v-flex>
      <v-layout wrap>
        <v-flex xs12>
          <v-chip style="font-size:20px" label outline color="green">
            <b>TOTAL TEMPS : {{totalHeuretrx}} HEURES  {{totalmintrx}} MINUTES </b>
          </v-chip>
          <v-chip style="font-size:20px" label outline color="green">
            <b>TOTAL DES WORKLOGS: {{totalactivitetrx}}</b>
          </v-chip>
        </v-flex>
      </v-layout>

       <v-flex xs12 class="elevation-1">
        <data-tables :data="listeWorktrx" border style="width:100%;">
          <el-table-column type="expand">
            <template slot-scope="props">
                <el-row>
                    <el-col :span="5">
                        <div class="grid-content bg-purple">

                                <b>Description</b> : <p>{{ props.row.description }}</p>

                        </div>

                       <v-tooltip bottom v-if="props.row.statutworklog !='Terminé'">
                            <v-btn @click="showAddActivite(props.row)"  slot="activator" flat  icon  color="blue">
                                <v-icon >add</v-icon>
                            </v-btn>
                          Ajouter Activités
                        </v-tooltip>

                    </el-col>

                    <el-col :span="19">
                       <div>
                          <b>Liste des Activités</b> :
                        </div>
                        <div class="elevation-3">

                              <el-table
                          :data="props.row.taches"
                          style="width: 100%">

                          <el-table-column
                            prop="libelle"
                            label="LIBELLE"
                           >
                          </el-table-column>
                           <el-table-column
                            prop="utilisateur"
                            label="ENREGISTRE PAR"
                            >
                          </el-table-column>
                           <el-table-column
                            prop="dateCreation"
                            label="DATE DE CREATION "
                           >
                          </el-table-column>
                          <el-table-column
                            prop="dateModification"
                            label="MODIFIER LE">
                          </el-table-column>
                            <el-table-column
                            prop="date"
                            label="DATE SYSTEME "
                           >
                          </el-table-column>
                           <el-table-column
                            prop="commentaire"
                            label="COMMENTAIRE">
                          </el-table-column>

                             <el-table-column  align="center"  prop="statut" label="STATUT"  width="260">
                                <template slot-scope="scope">
                                  <el-tag v-if="scope.row.statut == 'Terminée'" type="success" >{{scope.row.statut}}</el-tag>
                                  <el-tag v-if="scope.row.statut == 'En cours'" type="warning">  {{scope.row.statut}}</el-tag>
                                  <el-tag v-if="scope.row.statut == 'Aucune activitée'" type="info">  {{scope.row.statut}}</el-tag>
                                  <el-tag v-if="scope.row.statut == 'En attente'" type="danger">  {{scope.row.statut}}</el-tag>
                                  <!-- <el-tag v-if="scope.row.etat == 1" type="success">{{scope.row.libEtat}}</el-tag>
                                  <el-tag v-if="scope.row.etat == 2" >{{scope.row.libEtat}}</el-tag>
                                  <el-tag v-if="scope.row.etat == 4" type="danger" >{{scope.row.libEtat}}</el-tag> -->
                              </template>
                            </el-table-column>
                          <!-- <el-table-column
                            prop="statut"
                            label="STATUT"
                            >
                          </el-table-column> -->
                           <el-table-column label="ACTION" align="center" width="80" fixed="right">
                            <template slot-scope="scop" >
                              <v-icon  v-if="scop.row.statut == 'Terminée'" color="green">done</v-icon>
                               <v-btn
                                 :disabled="props.row.close" v-if="scop.row.statut !='Terminée' "
                                  @click.native="showDialogActiviteEdit(scop.row)"
                                  slot="activator"
                                  color="orange"
                                  fab
                                  dark
                                  small
                                >
                                  <v-icon>edit</v-icon>
                                </v-btn>
                               <v-btn
                                  :disabled="props.row.close" v-if="scop.row.statut !='Terminée' "
                                  @click.native="showDialogSuppActivite(scop.row)"
                                  slot="activator"
                                  color="red"
                                  fab
                                  dark
                                  small
                                >
                                  <v-icon>delete</v-icon>
                                </v-btn>
                            </template>
                          </el-table-column>
                        </el-table>
                        </div>
                    </el-col>
                </el-row>
            </template>
          </el-table-column>
         <el-table-column prop="idwork" label="ID" align="center" ></el-table-column>
          <el-table-column prop="libelle" label="LIBELLE" align="center" width="200" ></el-table-column>
          <el-table-column prop="description" label="DESCRIPTION" align="center" width="200" ></el-table-column>
          <el-table-column prop="tempsmis" label="TEMPS MIS" align="center" width="150"></el-table-column>
          <el-table-column prop="enregistrer" label="ENREGIRSTRE PAR" align="center" width="200"></el-table-column>
          <el-table-column prop="dateAdd" label="DATE DE CREATION" align="center"  width="200"></el-table-column>
          <el-table-column prop="dateModification" label="DATE DE MODIFICATION" align="center"  width="200"></el-table-column>
          <el-table-column prop="date" label="DATE SYSTEME" align="center"  width="200"></el-table-column>
           <el-table-column  align="center"  prop="statutworklog" label="STATUT"  width="200">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.statutworklog == 'Terminé'" type="success" >{{scope.row.statutworklog}}</el-tag>
                  <el-tag v-if="scope.row.statutworklog == 'En cours'" type="warning">  {{scope.row.statutworklog}}</el-tag>
                  <el-tag v-if="scope.row.statutworklog == 'Aucune activitée en cours'" type="info">  {{scope.row.statutworklog}}</el-tag>
                  <!-- <el-tag v-if="scope.row.etat == 1" type="success">{{scope.row.libEtat}}</el-tag>
                  <el-tag v-if="scope.row.etat == 2" >{{scope.row.libEtat}}</el-tag>
                  <el-tag v-if="scope.row.etat == 4" type="danger" >{{scope.row.libEtat}}</el-tag> -->
              </template>
            </el-table-column>
          <el-table-column label="ACTION" align="center" width="250" fixed="right">
            <template slot-scope="scope" >
              <v-tooltip bottom>
                <v-btn  @click.native="showDialogWorklogDetail(scope.row)" slot="activator" color="purple" fab dark small>
                  <v-icon>description</v-icon>
                </v-btn>Détails
              </v-tooltip>
              <!-- <v-icon v-if="scope.row.statutworklog == 'Terminé'"  color="green">done</v-icon>  -->
              <v-tooltip bottom  >
                <v-btn @click.native="showEditWork(scope.row)" v-if="scope.row.statutworklog != 'Terminé'" slot="activator" color="orange" fab dark small>
                  <v-icon>edit</v-icon>
                </v-btn>Modifier
              </v-tooltip>

              <v-tooltip bottom  >
                <v-btn
                  @click.native="showDilogSupp(scope.row)" v-if="scope.row.statutworklog != 'Terminé'"
                  slot="activator"
                  color="red"
                  fab
                  dark
                  small
                >
                  <v-icon>delete</v-icon>
                </v-btn>Supprimer
              </v-tooltip>
            </template>
          </el-table-column>
        </data-tables>
      </v-flex>

    </v-layout>

    <!-- MODAL SUPPRESSION DEMANDE -->
    <v-dialog v-model="dialogSupr" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline">Supprimer cet enregistrement ?</v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="mb-2">
              <el-alert
                title="La suppression est définitive"
                :closable="false"
                show-icon
                type="warning"
              ></el-alert>
            </v-flex>
            <v-flex xs12>
              <p class="grey--text font-weight-thin body-1">LIBELLE:</p>
              <p class="black--text .font-weight-regular subheading">ID-28}</p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" dark @click="dialogSupr = false">
            Annuler
            <v-icon right>remove_circle</v-icon>
          </v-btn>
          <v-btn color="red darken-1" dark @click="deleteDoc()">
            Supprimer
            <v-icon right>delete</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- MODAL SUPPRESSION DEMANDE -->

        <!-- MODAL AJOUT WORKLOG -->
        <v-dialog v-model="dialogWork" width="80%" :overlay="true" transition="dialog-bottom-transition" scrollable persistent>
          <v-card tile>
            <v-toolbar card dark color="primary">
              <v-toolbar-title>
                <span v-if="newVersion == true">Ajouter un nouveau worklog</span>
                <span v-if="newVersion == false">Modification du worklog</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click.native="dialogWork = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <el-form id="formWork" :model="formWork" ref="formWork" class="demo-form-inline">
                <v-layout row>
                  <v-flex xs4 class="mr-1">
                    <el-form-item label="Libellé" prop="libelle">
                      <el-input
                        v-model="formWork.libelle"
                        name="libelle"
                        required
                        placeholder="libelle"
                        style="width: 100%"
                      ></el-input>
                    </el-form-item>
                  </v-flex>

                   <v-flex xs4 class="mr-1">
                    <el-form-item label="Temps mis (Heure)" required style="width:100%">
                        <el-time-picker v-model="formWork.tempsmis" :disabled="!newVersion"  value-format="H-m" type="time" id="tempsmis" name="tempsmis" placeholder="Temps mis" style="width:100%">
                        </el-time-picker>
                    </el-form-item>
                </v-flex>

                  <v-flex xs4 class="mr-1">
                    <el-form-item label="Description" prop="description">
                      <el-input
                        type="textarea"
                        :rows="3"
                        v-model="formWork.description"
                        name="description"
                        placeholder="Description"
                        style="width: 100%"
                      ></el-input>
                    </el-form-item>
                  </v-flex>


                <v-flex xs4 class="mr-1">
                    <el-form-item label="Date de création" required style="width:100%">
                        <el-date-picker v-model="formWork.dateAdd"  :disabled="!newVersion" value-format="dd-MM-yyyy" type="date" id="dateAdd" name="dateAdd" placeholder="Date" style="width:100%">
                        </el-date-picker>
                    </el-form-item>
                </v-flex>

                </v-layout>

                <v-layout row>
                  <v-flex xs4 class="ml-3">

                            <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="logoWorklog" alt="avatar"></v-avatar><br/>
                            <input name="docs" type="file" style="display:none" ref="fileLogo" accept="image/*" @change="onFileImageLogoPicked"/>
                            <v-btn color="primary" class="white--text" required @click.native="$refs.fileLogo.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn><br/>

                            <!-- <div class="font-weight-thin" >Fichier au format (JPEG,PNG,PDF) avec une taille de 1048 ko maximale</div> -->
                    <p class="font-weight-thin">Format (JPEG,PNG,PDF), 10 Mo maximum</p>
                  </v-flex>
                </v-layout>
                <br />
                <v-layout row>
                  <v-flex xs12 class="mt-2">
                    <el-form-item class="text-xs-right">

                      <v-btn color="grey" @click="resetForm('formWork'),resetForm('tableTaches'),dialogWork = false" dark>
                        Annuler
                        <v-icon right>remove_circle</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="newVersion == true"
                        icons
                        dark
                        color="green"
                        @click="addWork('formWork')"
                      >
                        Enregistrer
                        <v-icon right>save</v-icon>
                      </v-btn>
                      <v-btn  v-if="newVersion == false" icons dark color="green" @click="editWork('formWork')">
                        Modifier
                        <v-icon right>add</v-icon>
                      </v-btn>
                    </el-form-item>
                  </v-flex>
                </v-layout>
              </el-form>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>
        <!-- MODAL FIN AJOUT WORKLOG  -->


     <!-- MODAL AJOUT ACTIVITE -->
          <v-dialog
            v-model="dialogActivite"
            width="80%"
            persistent

            transition="dialog-bottom-transition"
            scrollable
          >
            <v-card tile>
              <v-toolbar card dark color="primary">
                <v-toolbar-title v-if="newVersion == true">
                Ajouter des activitées au worklog {{Worklog.libelle}}
                </v-toolbar-title>
                <v-toolbar-title v-if="newVersion == false">
                Modifier l'état de l'activitée
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click.native="dialogActivite = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text>
                <el-form id="formActivite" :model="formActivite" ref="formActivite" class="demo-form-inline">
                  <v-layout row>
                    <v-flex xs4 class="mr-1">
                      <el-form-item label="Libellé" prop="libelle">
                        <el-input :disabled="!newVersion"
                          v-model="formActivite.libelle"
                          name="libelle"
                          required
                          placeholder="libelle"
                          style="width: 100%"
                        ></el-input>
                      </el-form-item>
                    </v-flex>
                      <v-flex xs4 class="mr-1">
                          <el-form-item label="Statut" prop="statut">
                            <el-select v-model="formActivite.statut" style="width:100%">
                              <el-option
                                v-for="item in typeLivraison"
                                :key="item.value"
                                :label="item.text"
                                :value="item.text"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </v-flex>

                      <v-flex xs4 class="mr-1">
                        <el-form-item label="Date de création"  prop="date"  style="width:100%">
                            <el-date-picker v-model="formActivite.date" :disabled="!newVersion" value-format="dd-MM-yyyy" type="date" id="date" placeholder="Date" style="width:100%">
                            </el-date-picker>
                        </el-form-item>
                    </v-flex>

                    <v-flex xs4 class="mr-1">
                      <el-form-item label="Commentaire" prop="commentaire">
                        <el-input
                          type="textarea"
                          :rows="3"
                          v-model="formActivite.commentaire"
                          name="commentaire"
                          placeholder="Description"
                          style="width: 100%"
                        ></el-input>
                      </el-form-item>
                    </v-flex>
                  </v-layout>
                  <v-layout row v-if="newVersion == true">
                  <el-button type="primary" @click="addListTaches(formActivite)">Ajouter</el-button>
                  </v-layout>
                  <br />


                    <el-table  v-if="newVersion == true" :data="tableTaches" style="width: 100%">
                      <el-table-column prop="libelle" label="Libellé"></el-table-column>
                      <el-table-column prop="statut" label="Statut"></el-table-column>
                      <el-table-column prop="date" label="Date de création"></el-table-column>
                      <el-table-column prop="commentaire" label="Commentaire"></el-table-column>
                      <el-table-column label="Operations">
                        <template slot-scope="scope">
                          <v-tooltip top>
                            <v-btn
                              slot="activator"
                              fab
                              small
                              icons
                              color="red"
                              @click.native.prevent="deleteRow(scope.$index, tableTaches)"
                              dark
                            >
                              <v-icon center>delete</v-icon>
                            </v-btn>Supprimer cet article
                          </v-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>


                  <v-layout row>
                    <v-flex xs12 class="mt-2">
                      <el-form-item class="text-xs-right">
                        <v-btn color="grey" @click.native="dialogActivite = false" dark>
                          Annuler
                          <v-icon right>remove_circle</v-icon>
                        </v-btn>
                        <v-btn
                          icons
                          dark
                          color="green" v-if="newVersion == true"
                          @click="addActivite('formActivite')"
                        >
                          Enregistrer
                          <v-icon right>save</v-icon>
                        </v-btn>
                        <v-btn  v-if="newVersion == false" icons dark color="green" @click="editTache('formActivite')">
                          Modifier
                          <v-icon right>edit</v-icon>
                        </v-btn>
                      </el-form-item>
                    </v-flex>
                  </v-layout>
                </el-form>
              </v-card-text>
              <div style="flex: 1 1 auto;"></div>
            </v-card>
          </v-dialog>
    <!-- MODAL FIN AJOUT ACTIVITE  -->


        <!-- MODAL SUPPRESSION ACTIVITE -->
            <v-dialog v-model="dialogSuprActivite" persistent max-width="50%" >
              <v-card>
                <v-card-title class="headline">Supprimer cet enregistrement ?</v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 class="mb-2">
                      <el-alert
                        title="La suppression est définitive"
                        :closable="false"
                        show-icon
                        type="warning"
                      ></el-alert>
                    </v-flex>
                    <v-flex xs12>
                      <p class="grey--text font-weight-thin body-1">Activité</p>
                      <p class="black--text .font-weight-regular subheading">Activité- {{ActiviteSelect.libelle}}</p>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="grey darken-1" dark @click="dialogSuprActivite = false">
                    Annuler
                    <v-icon right>remove_circle</v-icon>
                  </v-btn>
                  <v-btn
                    color="red darken-1"
                    dark
                    @click="deleteActivite()"
                  >
                    Supprimer
                    <v-icon right>delete</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
        <!-- MODAL SUPPRESSION ACTIVITE -->

         <!-- MODAL SHOW WORKLOG -->
        <v-dialog v-model="dialogShowWorklog" max-width="80%" :overlay="true" scrollable persistent>
          <v-card>
            <v-toolbar style="flex: 0 0 auto;" dark class="blue">
              <v-toolbar-title>Détails du worklog {{worklogCourant.libelle}} </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="dialogShowWorklog = false" dark><v-icon>close</v-icon> </v-btn>
            </v-toolbar>

            <v-card-text>
              <el-row :gutter="20">
                <div class="grid-content bg-purple">
                  <el-card class="box-card"  style="background:#F9FAFC">
                    <div class="text item">
                      <v-layout row wrap>
                        <v-flex md6>
                          <p><b>Libellé : </b> {{worklogCourant.libelle}} </p>
                          <p><b>Identifiant : </b> {{worklogCourant.id}} </p>
                          <p><b>Temps mis (Heure) : </b> {{worklogCourant.tempsmis}} </p>
                          <p><b>Description :</b> {{worklogCourant.description}}  </p>
                        </v-flex>
                        <v-flex md6>
                          <p><b>Statut : </b> {{worklogCourant.statutworklog}} </p>
                          <p><b>Ajouter par : </b> {{worklogCourant.enregistrer}} </p>
                          <p><b>Date d'enregistrement :</b> {{ worklogCourant.date }} </p>
                          <p><b>Date de modification :</b> {{ worklogCourant.dateModification}} </p>
                           <p>
                            <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="worklogCourant.urlImage" alt="avatar"/></v-avatar>
                          </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </el-card>
                      <br>
                      <p>Liste des activitées </p>
                  <el-card class="box-card"  style="background:#F9FAFC">
                    <div class="text item">
                      <v-layout row wrap>
                        <!-- <div class="elevation-3"> -->

                                  <el-table
                              :data="worklogCourant.taches"
                              style="width: 100%">
                              <el-table-column
                                prop="libelle"
                                label="LIBELLE"
                              >
                              </el-table-column>


                              <el-table-column
                                prop="utilisateur"
                                label="ENREGISTRER PAR"
                                >
                              </el-table-column>
                              <el-table-column
                                prop="dateCreation"
                                label="DATE DE CREATION "
                              >
                              </el-table-column>
                              <el-table-column
                                prop="dateModification"
                                label="MODIFIER LE">
                              </el-table-column>
                                <el-table-column
                                prop="date"
                                label="DATE SYSTEME "
                              >
                              </el-table-column>
                              <el-table-column
                                prop="commentaire"
                                label="COMMENTAIRE">
                              </el-table-column>

                               <el-table-column
                                prop="statut"
                                label="STATUT"
                                >
                              </el-table-column>
                            </el-table>
                            <!-- </div>  -->
                      </v-layout>
                    </div>
                  </el-card>


                  <v-tooltip top>
                    <v-btn slot="activator" icons color="orange" @click.stop="dialogShowWorklog = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
                    Fermer
                  </v-tooltip>
                  <!-- <v-tooltip top>
                  <v-btn slot="activator" icons color="primary" @click.stop="showDialogVersionEdit(worklogCourant)" dark>Mofifier <v-icon right>edit</v-icon></v-btn>
                  Modifier
                </v-tooltip> -->
                </div>
              </el-row>
            </v-card-text>


            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>
        <!-- END MODAL SHOW WORKLOG -->

  </div>
</template>

<script>
import Loading from "@/components/Loading";

export default {
  components: { Loading },
  name: "ListeWorklog",
  props: {
    show: {
      type: Boolean
    },
    idChantier: {
      type: Number
    },
    listeWorklog: {
      type: Array
    },
    listeWorktrx: {
      type: Array
    },
    listeTacheWorktrx: {
      type: Array
    },
    listeWorktrx2: {
      type: Array
    },
    totalHeuretrx: 0,
    totalmintrx: 0,
    totalactivitetrx: 0
  },

  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),

      formWork: [{
        libelle:"",
        tempsmis:"",
        description:"",
        dateAdd:"",
        file: null,
      }],
      formActivite: {},
      checked: false,
      tableTaches: [],
      tableTachesAffICh: [],
      typeLivraison: [
        { text: "En attente", value: 1 },
        { text: "En cours", value: 2 },
        { text: "Terminée", value: 3 }
      ],
      formTaches: {},
      selectTypeLivraison: "",
      logoWorklog: "/static/img-doc.png",

      editForm: false,
      dialogSupr: false,
      newVersion : true,
      dialogShowWorklog: false,
      dialogShowArticle: false,
      dialogSuprActivite: false,
      docSelect: {},
      ActiviteSelect: {},
      worklogCourant: {},
      Worklog: {},
      dialogWork: false,
      dialogActivite: false
    };
  },

  watch: {
    show: function(newValue, oldvalue) {
      if (newValue == true) {
        this.loadWork(idChantier);
      }
    }
  },

  methods: {

     showDialogSuppActivite(item){
      this.ActiviteSelect = item;
      this.dialogSuprActivite = true;
    },
    showDilogSupp(item) {
      this.docSelect = item;
      this.dialogSupr = true;
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);


    },
     showDialogWorklogDetail(item) {
      this.dialogShowWorklog = true
      this.worklogCourant = item
    },
     showDialogActiviteEdit(item)
    {
       this.dialogActivite = true;
       this.newVersion = false;
        this.formActivite = item;
        this.Worklog = item;
    },
    imprimeMatricePDF () {
      let url = this.domaine + 'worklogs/'+this.idChantier+'/'+this.user.id+'/imprimer_worklog_pdf';
        window.open(url)
    },
    //enregistrement des images
    onFileImageLogoPicked(event)
    {
        const files = event.target.files
        let filename = files[0].name
        if (filename.lastIndexOf(".") <= 0)
        {
            return alert("Veuillez selectionner un  format de fichier valide ")
        }

        const fileReader = new FileReader()
        fileReader.addEventListener("load", () => {
            this.logoWorklog = fileReader.result
        })

        fileReader.readAsDataURL(files[0])
        this.logoWorklog = files[0]

    },

     deleteActivite(formNameWork){
        this.loading = true;
         let form = document.getElementById("formActivite");
          let data = new FormData(form);
        let url =
        this.domaine + "tacheworklog/delete/activite/" + this.ActiviteSelect.worklog;
        data.append("ActiviteSelect", JSON.stringify(this.ActiviteSelect));

      this.$http.post(url,data).then(
        response => {
          this.loading = false;
          this.loadWork()

          this.$notify({
            title: "SUPPRESSION",
            message: "Activité supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSuprActivite = false;
        },
        errRep => {
          this.loading = false;
          this.dialogSuprActivite = false;
          this.$notify.error({
            title: "SUPPRESSION ECHOUEE",
            message: "La suppression du worklog a échouée.",
            position: "top-center"
          });
        }
      );
    },
    editTache(formNameWork) {
      // this.editForm = false;
      this.$refs[formNameWork].validate(valid => {
        if (valid) {
          this.loading = true;
          let form = document.getElementById("formActivite");
          let data = new FormData(form);
          let url = this.domaine + "tacheworklog/edit/taches/" + this.Worklog.worklog;
          data.append("statut",this.formActivite.statut)
          data.append("worklog", JSON.stringify(this.Worklog));
          data.append("libelle",this.formActivite.libelle)
          data.append("commentaire",this.formActivite.commentaire)

          data.append("userId", this.user.id);
          data.append("idChantier", this.idChantier);
          this.loading = false;
          this.dialogActivite = false;
          this.$http.post(url, data).then(
            resp => {
              this.loading = false;
              this.resetForm("formWork");
              this.dialogActivite = false;
              this.loadWork();
              this.successNotif(resp.body.message);
            },

            error => {
              this.loading = false;
              //this.resetForm('formWork');
              this.$message.error(
                "Une erreur est survenue lors de l'enregistrement du document"
              );
            }
          );
        }
      });
    },
    showAddActivite(item){
      this.newVersion = true;
      this.dialogActivite = true;
      this.Worklog = item;
      this.formActivite= {},
      this.tableTaches= [],
      this.resetForm();
    },
    modifTacheEtat(item){
          let form = document.getElementById("formWork");
          let data = new FormData(form);

          let url = this.domaine + "tacheworklog/edit/"+ this.Worklog.id;
          data.append("userId", this.user.id);
          data.append("tachesTAB", JSON.stringify(this.tableTaches));
          data.append("formTaches", this.formTaches);
          data.append("idChantier", this.idChantier);
          this.loading = false;

          this.$http.post(url, data).then(
            resp => {
              this.loading = false;
              this.loadWork();
              this.successNotif(resp.body.message);
            },

            error => {
              this.loading = false;
              //this.resetForm('formWork');
              this.$message.error(
                "Une erreur est survenue lors de l'enregistrement du document"
              );
            }
          );

    },
    addListTaches(item) {
      this.tableTaches.push({
        libelle: item.libelle,
        statut: item.statut,
        date: item.date,
        commentaire: item.commentaire,

      });
      this.formActivite = {};
    },
    loadWork(idChantier) {
      this.loading = true;
      this.docSelect = null;
      let url = this.domaine + "worklogs/chantier/" + this.idChantier;
      this.$http.get(url).then(
        response => {

          this.listeWorktrx = response.body.listeWorklog;
          this.listeTacheWorktrx = response.body.listTacheeWorklog;
          this.totalHeuretrx = response.body.totalheure;
          this.totalmintrx = response.body.totalMinutes;
          this.totalactivitetrx = response.body.totalActivite;

          this.loading = false;
        },
        response => {
          this.loading = false;
        }
      );
    },
    showAjoutWork() {

      this.editForm =  false;
      this.formWork = {};
      this.dialogWork = true;
      this.newVersion = true;
      this.logoWorklog = '/static/img-doc.png';



    },
    addWork(formNameWork) {
      this.editForm = false;
      this.$refs[formNameWork].validate(valid => {
        if (valid) {
          this.loading = true;
          let form = document.getElementById("formWork");
          let data = new FormData(form);
          let url = this.domaine + "worklogs/create";

          data.append("userId", this.user.id);
          data.append("tachesTAB", JSON.stringify(this.tableTaches));
          data.append("idChantier", this.idChantier);
          this.loading = false;

          this.$http.post(url, data).then(
            resp => {
              this.editForm = false;
              this.loading = false;
              this.resetForm("formWork");
              this.resetForm("formTaches");
              this.loadWork();
              this.dialogWork = false;
               this.successNotif(resp.body.message);
            },

            error => {
              this.loading = false;
              this.dialogWork = false;
              //this.resetForm('formWork');
              this.$message.error(
                "Une erreur est survenue lors de l'enregistrement du document"
              );
            }
          );
        }
      });
    },
    addActivite(formNameWork) {
      this.editForm = false;
      this.$refs[formNameWork].validate(valid => {
        if (valid) {
          this.loading = true;
          let form = document.getElementById("formWork");
          let data = new FormData(form);
          let url = this.domaine + "tacheworklog/create";

          data.append("userId", this.user.id);
          data.append("tachesTAB", JSON.stringify(this.tableTaches));
          data.append("idChantier", this.idChantier);
          data.append("idworklog", this.Worklog.id);

          this.$http.post(url, data).then(
            resp => {
              this.loading = false;
              this.resetForm("formActivite");
              this.resetForm("tableTaches");
               this.dialogActivite = false;
              this.loadWork();
              this.successNotif(resp.body.message);
            },

            error => {
              this.loading = false;
              //this.resetForm('formWork');
              this.$message.error(
                "Une erreur est survenue lors de l'enregistrement du document"
              );
            }
          );
        }
      });
    },

    showEditWork(item) {
      this.docSelect = item;
      // this.editForm = true;
      this.formWork = item;
      this.tableTaches = item;
      this.newVersion = false;
       this.editForm =  false;

      // this.resetForm();
      this.dialogWork = true;
       this.logoWorklog =item.urlImage;


    },
    editWork(formNameWork) {
      // this.editForm = false;
      this.$refs[formNameWork].validate(valid => {
        if (valid) {
          this.loading = true;
          let form = document.getElementById("formWork");
          let data = new FormData(form);
          let url = this.domaine + "worklogs/edit/" + this.docSelect.id;
          data.append("tachesTAB", JSON.stringify(this.tableTaches));
          data.append("userId", this.user.id);
          data.append("idChantier", this.idChantier);
          this.loading = false;
           this.dialogWork = false;
          this.$http.post(url, data).then(
            resp => {
              this.loading = false;
              this.resetForm("formWork");
              this.dialogWork = false;
              this.loadWork();
              this.successNotif(resp.body.message);
            },

            error => {
              this.loading = false;
              this.dialogWork = false;
              this.resetForm('formWork');
              this.$message.error(
                "Une erreur est survenue lors de l'enregistrement du document"
              );
            }
          );
        }
      });
    },

    deleteDoc() {
      this.loading = true;
      let url = this.domaine + "worklogs/delete/" + this.docSelect.id;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.loadWork();

          this.$notify({
            title: "SUPPRESSION",
            message: "Worklog supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSupr = false;
        },
        errRep => {
          this.loading = false;
          this.dialogSupr = false;
          this.$notify.error({
            title: "SUPPRESSION ECHOUEE",
            message: "La suppression du worklog a échouée.",
            position: "top-center"
          });
        }
      );
    },
    successNotif(mess = "Worklog enregistré avec succès", type = "success") {
      this.$notify({
        title: "ENREGISTREMENT DOCUMENT",
        message: mess,
        type: type,
        position: "top-center",
        duration: 10000
      });
    },

    resetForm(formNameWork) {
      this.formWork = [];
      this.tableTaches= [];
      this.formWork.urlImage = "/static/doc.png";
      this.file = null;
    },
    onFileImagePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }
      if (files[0].size > 10485760) {
        this.$message.error("La taille du fichier est supérieur à 10M");
        return;
      }
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.formWork.urlImage = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.formWork.file = files[0];
    }
  },

  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/worklogs/ListeWorklog.vue